import { render, staticRenderFns } from "./docMain.vue?vue&type=template&id=07dc9290&scoped=true&"
import script from "./docMain.vue?vue&type=script&lang=js&"
export * from "./docMain.vue?vue&type=script&lang=js&"
import style0 from "./docMain.vue?vue&type=style&index=0&id=07dc9290&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dc9290",
  null
  
)

export default component.exports